import styled from 'styled-components';
import { VIEWPORTS } from '@constants';

/* Global styles that are shared by many components (not just slides) */

export const Button = styled.button`
    -webkit-appearance: none;
    border: none;
    outline: none;
    background: #fff;
    font-family: ${props => props.theme.sansSerif};
    font-size: ${props => props.theme.smallFont};
    cursor: pointer;
    padding: 0;
    border-radius: 20px;
    display: flex;
    align-items: center;
    text-align: center
    box-sizing: border-box;
    transition: 0.2s ease;
    &:hover {
        background: ${props => props.hover || props.theme.lightGrey};
    }
`;

export const InfoDropDownButton = styled(Button)`
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
`;

function getLogoWidth(view, viewport) {
    const { mobile } = VIEWPORTS;

    switch(view) {
        case 'slide':
            return viewport === mobile ? '30px' : '103px';
        case 'admin':
            return '125px';
        case 'navbar':
            return '125px';
        case 'intro':
            return '185px';
    }
}

function getLogoPosition(view, desktop) {
    if (view === 'slide' && desktop) {
        return '24px';
    } else if (view === 'slide' && !desktop) {
        return '15px';
    }

    return '0';
}

export const LogoImage = styled.img`
    width: ${props => getLogoWidth(props.view, props.viewport)};
    position: relative;
    cursor: pointer;
    right: ${({ view, desktop }) => getLogoPosition(view, desktop)};
`;

LogoImage.defaultProps = {
    view: 'slide'
};
